/* eslint-disable complexity */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';

import { QUERY_PARAMS } from '@futrli/shared-services';

import { ScenarioOnboardingNav } from './scenario-onboarding-nav';
import { SCENARIO_ONBOARDING_STEP } from '../const';
import { EndOnboardingFlow } from '../components/end-onboarding-flow';
import * as styles from './scenario-onboarding-container.scss';
import { ForecastType, OnboardingTypeSelect } from '../shared/onboarding-type-select';
import { OnboardingHistoricalData } from './onboarding-historical-data';
import { OnboardingControlWhatYouSee } from './onboarding-control-what-you-see';
import { OnboardingCustomise } from '../shared/onboarding-customise';
import { OnboardingControlCashflow } from './onboarding-control-cash-flow';
import { OnboardingAdditionalControls } from '../shared/onboarding-additional-controls';
import { OnboardingReadyToGo } from '../shared/onboarding-ready-to-go';
import { OnboardingActivity } from '../shared/onboarding-activity';
import { OnboardingExplained } from '../shared/onboarding-explained';
import { OnboardingToggleOff } from '../shared/onboarding-toggle-off';

export const ScenarioOnboardingContainer = () => {
  const { onboardingStep } = useParams();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const forecastType = searchParams.get(QUERY_PARAMS.FORECAST_TYPE);

  const getOnboardingContent = () => {
    if (forecastType === ForecastType.FromScratch) {
      switch (onboardingStep) {
        case SCENARIO_ONBOARDING_STEP.SCRATCH_HISTORICAL:
          return <OnboardingHistoricalData />;
        case SCENARIO_ONBOARDING_STEP.SCRATCH_CONTROL_WHAT_YOU_SEE:
          return <OnboardingControlWhatYouSee />;
        case SCENARIO_ONBOARDING_STEP.SCRATCH_CUSTOMISE:
          return <OnboardingCustomise />;
        case SCENARIO_ONBOARDING_STEP.SCRATCH_CONTROL_CASH_FLOW:
          return <OnboardingControlCashflow />;
        case SCENARIO_ONBOARDING_STEP.SCRATCH_ADDITIONAL_CONTROLS:
          return <OnboardingAdditionalControls />;
        case SCENARIO_ONBOARDING_STEP.SCRATCH_READY_TO_GO:
          return <OnboardingReadyToGo />;
        default:
          return <OnboardingHistoricalData />;
      }
    } else if (forecastType === ForecastType.WithAutoPredictions) {
      switch (onboardingStep) {
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_ACTIVITY:
          return <OnboardingActivity />;
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_EXPLAINED:
          return <OnboardingExplained />;
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_HISTORICAL:
          return <OnboardingHistoricalData />;
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_WHAT_YOU_SEE:
          return <OnboardingControlWhatYouSee />;
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE:
          return <OnboardingCustomise />;
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_CONTROL_CASH_FLOW:
          return <OnboardingControlCashflow />;
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_ADDITIONAL_CONTROLS:
          return <OnboardingAdditionalControls />;
        case SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_READY_TO_GO:
          return <OnboardingReadyToGo />;
        default:
          return null;
      }
    } else if (forecastType === ForecastType.FromLYA) {
      switch (onboardingStep) {
        case SCENARIO_ONBOARDING_STEP.LYA_TOGGLE_OFF:
          return <OnboardingToggleOff />;
        case SCENARIO_ONBOARDING_STEP.LYA_HISTORICAL:
          return <OnboardingHistoricalData />;
        case SCENARIO_ONBOARDING_STEP.LYA_CONTROL_WHAT_YOU_SEE:
          return <OnboardingControlWhatYouSee />;
        case SCENARIO_ONBOARDING_STEP.LYA_CUSTOMISE:
          return <OnboardingCustomise />;
        case SCENARIO_ONBOARDING_STEP.LYA_CONTROL_CASH_FLOW:
          return <OnboardingControlCashflow />;
        case SCENARIO_ONBOARDING_STEP.LYA_ADDITIONAL_CONTROLS:
          return <OnboardingAdditionalControls />;
        case SCENARIO_ONBOARDING_STEP.LYA_READY_TO_GO:
          return <OnboardingReadyToGo />;
        default:
          return null;
      }
    } else {
      switch (onboardingStep) {
        case SCENARIO_ONBOARDING_STEP.SELECT_TYPE:
          return <OnboardingTypeSelect />;
        default:
          return <OnboardingTypeSelect />;
      }
    }
  };
  return (
    <div>
      <ScenarioOnboardingNav />
      {getOnboardingContent()}
      <EndOnboardingFlow />
      {onboardingStep === SCENARIO_ONBOARDING_STEP.CASH_FLOW_IMPORTANT && (
        <div className={styles.explanation}>
          <FormattedMessage
            id="onboarding.forecast_with_invoices_explained"
            defaultMessage="*This type of forecast will always have forecast data appearing from <b>the last data sync</b>, to ensure due invoices and bills are accurate. Choose traditional if you want to be able to edit when forecast data appears from."
            values={{
              b: (chunks: string) => <span style={{ fontWeight: 500 }}>{chunks}</span>
            }}
          />
        </div>
      )}
    </div>
  );
};
